import 'react-perfect-scrollbar/dist/css/styles.css';
import { Provider } from 'react-redux';
import 'src/components/GlobalStyles.css';
import MainRoute from 'src/routes';
import { AuthProvider } from 'src/context/AuthContext';
import { CustomThemeProvider } from 'src/context/ThemeContext';
import store from 'src/redux/store';
import { injectStore } from './api/api';
import SessionTimeoutModal from './common/SessionTimeoutModal';
import QueryProvider from './features/tyre-management/QueryProvider';

injectStore(store);

const App = () => (
  <QueryProvider>
    <Provider store={store}>
      <CustomThemeProvider>
        <AuthProvider>
          <SessionTimeoutModal />
          <MainRoute />
        </AuthProvider>
      </CustomThemeProvider>
    </Provider>
  </QueryProvider>
);

export default App;
